import { map } from 'lodash'
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  useFieldArray,
} from 'react-hook-form'

import { Checkbox, Label } from '@/components/ui'
import { UserGroupsDetails } from '../../../../common/models'
import FormGroup from '../../../../core/components/FormGroup'

export interface CreateUserPermissionsProps {
  nestIndex: number
  control: Control<UserGroupsDetails>
  register: UseFormRegister<UserGroupsDetails>
  errors: FieldErrors<UserGroupsDetails>
  watch: UseFormWatch<UserGroupsDetails>
  setValue: UseFormSetValue<UserGroupsDetails>
  disabled: boolean
}

export const CreateUserPermissions = (
  props: CreateUserPermissionsProps,
): JSX.Element => {
  const { nestIndex, control, register, errors, watch, setValue, disabled } =
    props

  const { fields } = useFieldArray({
    control,
    name: `permissionCategories.${nestIndex}.permissions`,
  })

  return (
    <>
      {fields.length > 0 && (
        <div className="flex flex-col w-full bg-monochrome-5 rounded-md border border-monochrome-120 p-4 space-y-7">
          {map(fields, (field, index) => {
            const viewWatch = watch(
              `permissionCategories.${nestIndex}.permissions.${index}.view`,
            )
            return (
              <div
                className="flex flex-col items-start gap-4 w-full"
                key={field.id}
              >
                {fields.length !== 1 && (
                  <Label className="text-title-xs font-semibold">
                    {field.name}
                  </Label>
                )}
                <div
                  className="flex flex-col items-start gap-4 w-full"
                  key={field.id}
                >
                  <div className="flex items-start gap-4 w-full">
                    <FormGroup
                      label="View"
                      direction="row"
                      labelClassName="whitespace-nowrap"
                    >
                      <Checkbox
                        checked={viewWatch || false}
                        onCheckedChange={(checked) => {
                          setValue(
                            `permissionCategories.${nestIndex}.permissions.${index}.view`,
                            Boolean(checked),
                          )
                          if (viewWatch) {
                            setValue(
                              `permissionCategories.${nestIndex}.permissions.${index}.edit`,
                              Boolean(checked),
                            )
                          }
                        }}
                        disabled={disabled}
                      />
                    </FormGroup>
                    <FormGroup
                      label="Edit"
                      direction="row"
                      labelClassName="whitespace-nowrap"
                    >
                      <Checkbox
                        checked={watch(
                          `permissionCategories.${nestIndex}.permissions.${index}.edit`,
                        )}
                        onCheckedChange={(checked) => {
                          setValue(
                            `permissionCategories.${nestIndex}.permissions.${index}.edit`,
                            Boolean(checked),
                          )
                        }}
                        disabled={disabled || !viewWatch}
                      />
                    </FormGroup>
                  </div>
                </div>
                {fields.length !== index + 1 && (
                  <div className="w-full col-span-full h-0 border-t border-monochrome-120" />
                )}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
